const _permissoes = new Map();

export const PermissoesPlugin = {
  install
};

function install(Vue, permissoes) {
  populatePermissoes(permissoes);

  Object.defineProperty(Vue.prototype, "$permissoes", {
    get() {
      return ContainsPermissao;
    }
  });

  Object.defineProperty(Vue.prototype, "$permissoesFuncionalidade", {
    get() {
      return ContainsPermissaoFuncionalidade;
    }
  });
}

function populatePermissoes(permissoes) {
  permissoes.forEach(permissao => _permissoes.set(permissao.key, permissao));

  _permissoes.contains = permissao => {
    if (permissao === "dev") {
      if (process.env.NODE_ENV !== "production") {
        return true;
      } else {
        console.warn(
          'Atenção! Você esta utilizando permissão "dev" em modo de produção'
        );
      }
    }
    return _permissoes.has(permissao);
  };
}

export function PermissoesFilterRoutes(routes) {
  return routes.filter(
    route =>
      route.redirect != null ||
      route.children != null ||
      route.meta.permissao === "public" ||
      _permissoes.contains(route.meta.permissao)
  );
}

export function PermissoesFilterMenu(menu) {
  return menu.filter(sessao => {
    sessao.itens = sessao.itens.filter(item => {
      if (typeof item === "string") {
        return true;
      } else if (item.subitens) {
        item.subitens = item.subitens.filter(subitem =>
          Array.isArray(subitem.permissao)
            ? subitem.permissao.some(_permissoes.contains)
            : _permissoes.contains(subitem.permissao)
        );
        return item.subitens.length > 0;
      } else {
        return Array.isArray(item.permissao)
          ? item.permissao.some(_permissoes.contains)
          : _permissoes.contains(item.permissao);
      }
    });

    return sessao.itens.length > 0;
  });
}

export function ContainsPermissao(permissao) {
  return _permissoes.contains(permissao);
}

export function ContainsPermissaoFuncionalidade(permissao, funcionalidade) {
  if (_permissoes.contains(permissao)) {
    return _permissoes.get(permissao).funcionalidades.includes(funcionalidade);
  }
  return false;
}
